//alert(true);
import './styles.editor.scss';
import { registerBlockType } from '@wordpress/blocks';
import ServerSideRender from '@wordpress/server-side-render';
import { __ } from '@wordpress/i18n';
import { Component, useState, useEffect, Fragment } from '@wordpress/element';
import IconWishListMember from '../icons/icon-wishlist-member';
import {
	Toolbar,
	ToolbarGroup,
	ToolbarItem,
	DropdownMenu,
	PanelBody,
	ToggleControl,
	Button,
	Disabled,
} from '@wordpress/components';
import { useBlockProps, InspectorControls } from '@wordpress/block-editor';

import Loading from '../loading';

registerBlockType('wishlist-box-basic-blocks/access-memberlevels', {
	title: __('Member Levels', 'wishlist-member'),
	description: __('Display Member Levels', 'wishlist-member'),
	category: 'wishlist-box-basic-blocks-category',
	keywords: [__('wlm'), __('member'), __('access')],
	icon: IconWishListMember,
	attributes: {
		content: {
			type: 'string',
			default: '[wlm_memberlevel]',
		},
	},
	edit(props) {
		const { attributes, setAttributes } = props;
		const blockProps = useBlockProps();

		const content = attributes.content;

		const output = (
			<ServerSideRender
				block="wishlist-box-basic-blocks/access-memberlevels"
				attributes={attributes}
				LoadingResponsePlaceholder={Loading}
			/>
		);

		return (
			<Fragment>
				<InspectorControls>
					<PanelBody
						title={__('Options', 'wishlist-member')}
					></PanelBody>
				</InspectorControls>
				<div {...blockProps}>
					<Disabled>
						<ServerSideRender
							block="wishlist-box-basic-blocks/access-memberlevels"
							attributes={attributes}
							// httpMethod="POST"
							LoadingResponsePlaceholder={Loading}
							// attributes={ {
							// 	sort: attributes.sort
							// } }
						/>
					</Disabled>
				</div>
			</Fragment>
		);
	},
	save(props) {
		return null;
	},
});
